import React from "react";
import ScheduledJobs from "../../Components/ScheduledJobs/ScheduledJobs";

function ScheduledJobsPage() {
  return <ScheduledJobs />;
}

export default ScheduledJobsPage;
